import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { EditType } from "./components/tiles/edit/edit";
import { Category, Poi } from "./models/Poi";
export default class PoiVuexModule extends AbacoVuexModule {

    @State() curPoi!: Poi | null;
    @State() allPoiFiltered!: Poi | null;
    @State() categorySelected!: Category | null;
    @State({ default: [] }) allPoi!: Poi[];
    @State() pointSelected!: number[] | null;
    @State({ default: 0 }) triggerMapAllPoiLayer!: number;
    @State({ default: 0 }) triggerMapUpdatePoiLayer!: number;
    @State({ default: 0 }) triggerSelect!: number;
    @State({ default: 0 }) triggerCategorySelect!: number;
    @State({ default: EditType.CREATE }) editStatus!: EditType;
    @State() pkBookmarkPoiSelected!: number | null;

}
